export default __webpack_public_path__ + "static/media/portable_en.3ca9642a.jpg";